import React from "react";

const ImportantStar = () => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.58456 1.53542C7.95914 0.777091 9.04081 0.777091 9.41539 1.53542L11.4371 5.63209L15.9579 6.28917C16.7954 6.41084 17.13 7.44001 16.5237 8.03043L13.2529 11.2192L14.025 15.7217C14.1679 16.5558 13.2925 17.1917 12.5437 16.7979L8.49998 14.6721L4.45623 16.7979C3.70748 17.1917 2.83206 16.5558 2.97498 15.7217L3.74748 11.2192L0.476228 8.03043C-0.130022 7.44001 0.204561 6.41084 1.04164 6.28917L5.56248 5.63209L7.58456 1.53542Z"
                fill="#FFC700"
            />
        </svg>
    );
};

export default ImportantStar;
